import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { from, lastValueFrom, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from '../services/appConfigService';
import { MsalService } from '@azure/msal-angular';
import { TokenCacheService } from '../services/Integration/TokenCacheService.service'
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private appService: AppConfigService,
    private tokenService: TokenCacheService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.headers.get('skip')) {
      return next.handle(req);
    } else {
      return from(this.handleAsync(req, next));
    }
  }

  private async handleAsync(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    var token = null;
    const apimFlag = this.appService.config.DATA.IS_APIM_ENDPOINT_ENABLED;
    const apimSubKey = this.appService.config.DATA.OCP_APIM_SUBSCRIPTION_KEY;

    if (req.url.toString().startsWith(this.appService.config.DATA.API_END_POINT.FINANCE_INTEGRATION_API_URL)) {
      token = 'Bearer ' + await this.tokenService.getTokenForDomain('accesstokenfinanceintegration');
    } else if (req.url.toString().startsWith(this.appService.config.DATA.API_END_POINT.CRM_INTEGRATION_API_URL)) {
      token = 'Bearer ' + await this.tokenService.getTokenForDomain('accesstokencrmintegration');
    } else if (req.url.toString().startsWith(this.appService.config.DATA.API_END_POINT.API_URL)) {
      token = 'Bearer ' + await this.tokenService.getTokenForDomain('accesstokenengageapi');
    } else if (req.url.toString().startsWith(this.appService.config.DATA.API_END_POINT.INTEGRATION_API_URL)) {
      token = 'Bearer ' + await this.tokenService.getTokenForDomain('accesstokenintegrationapi');
    }

    if (req.method === 'POST') {
      const newHeaders = req.headers;
      const body = req.body;
      const newBody = {
        ...body,
        userName: user.userName,
        loggedInUserEmail: user.loggedInUserEmail,
        firstName: user.firstName,
        lastName: user.lastName,
        loggedInUserFullName: user.loggedInUserFullName,
        role: user.role,
        activeDirectoryGroups: user.activeDirectoryGroups
      };

      req = req.clone({ headers: newHeaders, body: newBody });
    }

    if (token !== null) {
      if (apimFlag == true) {
        req = req.clone({
          setHeaders: {
            Authorization: token,
            'Ocp-Apim-Subscription-Key': apimSubKey
          }
        });
      }
      else {
        req = req.clone({
          setHeaders: {
            Authorization: token
          }
        });
      }
    }

    return await lastValueFrom(
      next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
        console.error(error); const localError = error.message || error.statusText;
        return throwError(() => localError);
      })
      )
    );
  }
}


